import script from "./contentTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./contentTemp.vue?vue&type=script&setup=true&lang=js"

import "./contentTemp.vue?vue&type=style&index=0&id=c69a59d4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c69a59d4"]])

export default __exports__